import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LineChartModel } from '../../model/line-chart/line-chart-model';
import { Player } from 'src/app/features/handball/player/model/player';
import { LineChartGraphComponent } from './line-chart-graph/line-chart-graph.component';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';
import {
  MatDatepicker,
  MatDatepickerInputEvent,
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate,
} from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-line-chart',
  templateUrl: 'line-chart.component.html',
  styleUrls: ['line-chart.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LineChartGraphComponent,
    MatIcon,
    MatFormField,
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerToggle,
    FormsModule,
    MatInputModule,
    MatStartDate,
    MatEndDate,
  ],
})
export class LineChartComponent implements OnInit {
  @Input() player: Player;
  performanceData: LineChartModel;
  isDataAvailable: boolean = false;

  startDate: Date = new Date(2025, 3, 10);
  endDate: Date = new Date(2025, 3, 26);

  get displayRange(): string {
    if (!this.startDate || !this.endDate) return 'Selecciona un periodo';
    const s = this.startDate;
    const e = this.endDate;
    const sDay = s.getDate().toString().padStart(2, '0');
    const eDay = e.getDate().toString().padStart(2, '0');
    const sMonth = s.toLocaleString('es-ES', { month: 'short' });
    const eMonth = e.toLocaleString('es-ES', { month: 'short' });

    return sMonth === eMonth
      ? `${sDay}–${eDay} ${sMonth}`
      : `${sDay} ${sMonth} – ${eDay} ${eMonth}`;
  }

  constructor() {}

  ngOnInit() {
    this.getPerformanceData();
  }

  private async getPerformanceData() {
    this.performanceData = {
      title: 'Rendimiento',
      series: [
        {
          label: 'Goles',
          data: [
            { value: 2, label: '10/04/2025' },
            { value: 3, label: '13/04/2025' },
            { value: 1, label: '17/04/2025' },
            { value: 4, label: '23/04/2025' },
            { value: 2, label: '26/04/2025' },
          ],
          color: '#47050b',
        },
        {
          label: 'Asistencias',
          color: '#19284c',
          data: [
            { value: 1, label: '10/04/2025' },
            { value: 2, label: '13/04/2025' },
            { value: 0, label: '17/04/2025' },
            { value: 1, label: '23/04/2025' },
            { value: 3, label: '26/04/2025' },
          ],
        },
        {
          label: 'Pérdidas',
          color: '#fe192f',
          data: [
            { value: 0, label: '10/04/2025' },
            { value: 1, label: '13/04/2025' },
            { value: 2, label: '17/04/2025' },
            { value: 1, label: '23/04/2025' },
            { value: 0, label: '26/04/2025' },
          ],
        },
      ],
    };
    if (
      !this.performanceData ||
      !this.performanceData?.series ||
      this.performanceData?.series?.length === 0
    ) {
      return;
    }

    this.isDataAvailable = true;
  }

  onDateChange() {
    if (this.startDate && this.endDate) {
      this.getPerformanceData();
    }
  }
}
